import React from "react";
import { ChevronProps } from "./types";

const SingleChevron = (props: ChevronProps) => {
	const { color, direction } = props;

	return (
		<React.Fragment key="single-chevron">
			{direction == "left" && (
				<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24" fill={color}>
					<path d="M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z" />
				</svg>
			)}
			{direction === "right" && (
				<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24" fill={color}>
					<path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z" />
				</svg>
			)}
			{direction === "up" && (
				<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24" fill={color}>
					<path d="m296-345-56-56 240-240 240 240-56 56-184-184-184 184Z" />
				</svg>
			)}
			{direction === "down" && (
				<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24" fill={color}>
					<path d="M480-345 240-585l56-56 184 184 184-184 56 56-240 240Z" />
				</svg>
			)}
		</React.Fragment>
	);
};

export default SingleChevron;
